<template>
  <div class="goods-list-box">
    <OperationBoxComponent :actions="actions" :filters="filters" :disabled="params.ids.length === 0" />
    <GoodsListComponent v-if="pageData" :page-data="pageData" @onSelectChanged="onSelectChanged" @goodsListChanged="updateGoodsList" @onPageChanged="onPageChanged" />
  </div>
</template>

<script>
import OperationBoxComponent from '../../../components/common/OperationBoxComponent'
import GoodsListComponent from '../../../components/goods/GoodsListComponent'
import {GoodsRequestUtil} from '../../../utils/GoodsRequestUtil'

export default {
  name: 'GoodsListPage',
  components: {
    GoodsListComponent,
    OperationBoxComponent
  },
  mounted () {
    this.updateGoodsList()
  },
  data () {
    return {
      actions: [
        { title: '', icon: 'el-icon-refresh', type: 'button', theme: 'primary', action: this.updateGoodsList },
        { title: '通过', type: 'button', theme: 'success', action: this.pass },
        { title: '拒绝', type: 'button', theme: 'warning', action: this.refuse },
        { title: '删除', type: 'button', theme: 'danger', action: this.remove },
        { title: '状态',
          type: 'select',
          action: this.onAuditStateChange,
          options: [
            {title: '待审核', value: 0},
            {title: '已通过', value: 1},
            {title: '已拒绝', value: 2}
          ]}
      ],
      filters: [{searchValue: '', type: 'title', title: '标题', options: [{title: '标题', value: 'title'}], action: this.onFilterChange}],
      pageData: {},
      params: {
        ids: []
      },
      queryParam: {
        page: 1,
        pageSize: 25,
        audit_state: null,
        type: null,
        keywords: null
      }
    }
  },
  methods: {
    updateGoodsList () {
      let that = this
      this.pageData = {}
      GoodsRequestUtil.queryGoodsList({queryParam: this.queryParam}, function (response) {
        if (response.items) {
          that.pageData = response
        }
      })
    },
    onAuditStateChange (item) {
      this.queryParam.page = 1
      this.queryParam.audit_state = parseInt(item.selectValue)
      this.updateGoodsList()
    },
    onFilterChange (item) {
      this.queryParam.page = 1
      this.queryParam.type = item.type
      this.queryParam.keywords = item.searchValue
      this.updateGoodsList()
    },
    pass () {
      GoodsRequestUtil.pass(this.params, this.updateGoodsList)
    },
    refuse () {
      GoodsRequestUtil.refuse(this.params, this.updateGoodsList)
    },
    remove () {
      GoodsRequestUtil.remove(this.params, this.updateGoodsList)
    },
    onSelectChanged (ids) {
      this.params.ids = ids
    },
    onPageChanged (page) {
      this.queryParam.page = page
      this.updateGoodsList()
    }
  }
}
</script>

<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/pages/whaledge/goods/GoodsListPage.vue